import type { IconSvgObject } from './types';

const TerminalIcon: IconSvgObject = [
  ["path", { d: "M4.00004 17L10 11L4 5", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "0" }],
  ["path", { d: "M12 19H20", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "1" }]
];

export default TerminalIcon;
